import PropTypes from 'prop-types';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Collapse } from '@mui/material';
// hooks
import useActiveLink from 'src/hooks/useActiveLink';
// components
import { NavSectionVertical } from 'src/components/nav-section';
//
import NavItem from './NavItem';

// ----------------------------------------------------------------------

export default function NavList({ item }) {
  const { pathname } = useLocation();
 console.log(item)
  const { path, children } = item;

  const { isExternalLink } = useActiveLink(path);
  console.log(isExternalLink)
  const [open, setOpen] = useState(false);
  console.log(item.children);
  return (
    <>
      <NavItem


        sx={{ padding: '30px', justifyContent: "center", alignItems: "center" }}
        item={item}
        open={open}
        onClick={() => setOpen(!open)}
        active={pathname === path}
        isExternalLink={item.title === "e-brochure" || item.title === "电子手册" ? true : isExternalLink}
      />

      {!!children && (
        <Collapse in={open} unmountOnExit>
          <NavSectionVertical data={children} />
        </Collapse>
      )}
    </>
  );
}

NavList.propTypes = {
  item: PropTypes.object,
};
